import script from "./VideoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPage.vue?vue&type=script&setup=true&lang=js"

import "./VideoPage.vue?vue&type=style&index=0&id=873108a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-873108a8"]])

export default __exports__